import {GenericService, ResultType} from '@/shared/xhttp';
import {Devis} from '@/models';

export class DevisService extends GenericService<Devis> {
	public async putChangeState(devis: Devis, refused: boolean): Promise<void> {
		await this.put(`/${devis.id}/change-state?refused=${refused}`);
	}
}